import Head from "next/head";
import styles from "../styles/main.module.css";
import Layout from "../src/layout";
import { parse } from "tldts";
import Login from "../shared/login";
import { pick } from "lodash";
 
export default function Home(props) {
  return (
    <div className={styles.container}>
      <Head>
        <title>Yupmedi</title>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Head>
      <Layout rootStyle={{ maxWidth: "100%" , padding: "0px" }}>
        <Login isVendor={true} />
      </Layout>
    </div>
  );
}

Home.messages = ["Home"];

export async function getServerSideProps(props) {
  const result = parse(props.req.headers.host);
 

  return {
    props: {
      messages: pick(
        await import(`../messages/${props.locale}.json`),
        Home.messages
      ),
    },
  };
}

function notFount() {
  return {
    redirect: {
      destination: `404`,
      permanent: false,
    },
  };
}
